/**
 * The procedure, and which parts of it are done.
 *
 * The order is not a convention; rule 9(1) makes it a matter of law, so each
 * stage carries the rule that puts it there.
 */

import { bi } from "@ksidc/ontology";
import { useLang } from "@ksidc/client";
import type { StageView } from "../api-types.js";
import { formatDate } from "../format.js";
import { CheckMark, ProvenanceRow } from "./ui.js";

export function StageList({ stages }: { stages: StageView[] }): JSX.Element {
  const { t } = useLang();

  return (
    <ol className="stages">
      {stages.map((stage) => (
        <li
          key={stage.key}
          className={["stage", stage.done ? "stage-done" : "stage-pending"].join(" ")}
        >
          <span className="stage-mark" aria-hidden="true">
            {stage.done ? <CheckMark /> : null}
          </span>
          <span className="stage-body">
            <span className="stage-title">{t(stage.label)}</span>
            <span className="sr-only">
              {stage.done
                ? t(bi(" — done", " — പൂർത്തിയായി"))
                : t(bi(" — not yet done", " — ഇതുവരെ ആയിട്ടില്ല"))}
            </span>
            <div className="muted">
              {stage.done
                ? t(
                    bi(
                      `Done on ${formatDate(stage.at, "en")}`,
                      `${formatDate(stage.at, "ml")}-ന് പൂർത്തിയായി`,
                    ),
                  )
                : t(bi("Not yet done", "ഇതുവരെ ആയിട്ടില്ല"))}
              {stage.form
                ? t(
                    bi(
                      ` · Recorded on Form ${stage.form}`,
                      ` · ഫോറം ${stage.form}-ൽ രേഖപ്പെടുത്തുന്നു`,
                    ),
                  )
                : ""}
            </div>
            <ProvenanceRow items={[stage.provenance]} />
          </span>
        </li>
      ))}
    </ol>
  );
}
